import { useEffect, useState } from "react";
import { ApiDataAccess } from "../infrastructure/ApiDataAccess";

import "./DataSourceDropdown.css";

export const DataSourceDropdown = (props) => {

    const [items, setItems] = useState([]);

    useEffect(() => {
        const init = async () => {
            var dataAccess = new ApiDataAccess('/api');
            dataAccess.get('/datasources/' + encodeURI(props.dataSourceName))
                .then(data => {
                    setItems(data);
                })
                .catch(() => {
                    setItems([]);
                });
        }
        init();
    }, []);

    const onChange = (evt) => {
        if (props.onChange) {
            var value = evt.target.value;
            if (!value || value == -1) {
                props.onChange(null);
            }
            else {
                props.onChange(value);
            }
        }
    }

    return (
        <select className='dropdown-form-control' onChange={onChange}>
            <option value={-1}>{props.selectMessage ? props.selectMessage : 'Please Select...'}</option>
            {items.map((item, idx) => {
                return (
                    <option value={item.id}>{item.name}</option>
                )
            })}
        </select>
    )
}